var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClipreact = function SvgClipreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "menu close"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8984",
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-attach-file",
    d: "M18.545 16.364H6a4.364 4.364 0 0 1 0-8.727h13.636a2.727 2.727 0 0 1 0 5.455H8.182a1.091 1.091 0 0 1 0-2.182h10.363V9.273H8.182a2.727 2.727 0 1 0 0 5.455h11.454a4.364 4.364 0 0 0 0-8.727H6a6 6 0 0 0 0 12h12.545Z"
  }))));
};

export default SvgClipreact;